import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  getActivityBellItems,
  selectActivityBell,
  selectActivityBellLoading,
} from 'redux/modules/activityBell';
import { clearBellNotifications } from 'redux/modules/auth';
import { useActions } from 'utils/useActions';

let isFetching = false;
let lastFetchTime = 0;
const CACHE_DURATION = 500;

export const useConnect = () => {
  const activityBell = useSelector(selectActivityBell);
  const isLoading = useSelector(selectActivityBellLoading);

  const actions = useActions({
    getActivityBell: getActivityBellItems.request,
    clearBellNotifications,
  });

  useEffect(() => {
    if (!activityBell) return;
    isFetching = false;
  }, [activityBell]);

  useEffect(() => {
    const now = Date.now();
    if (isFetching || now - lastFetchTime < CACHE_DURATION) return;

    isFetching = true;
    lastFetchTime = now;

    actions.getActivityBell({ page: 1, pageSize: 10 });
  }, [actions]);

  useEffect(() => {
    return () => {
      actions.clearBellNotifications();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const notifications = activityBell;

  return {
    isLoading,
    notifications,
  };
};
